import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withKeys as _withKeys, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6edecc6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-1 flex-justify-between" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "添加二级菜单", -1))
const _hoisted_4 = { class: "dialog-button" }
const _hoisted_5 = {
  key: 0,
  class: "text-color-red"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
    "show-close": false,
    "close-on-press-escape": false,
    "close-on-click-modal": false,
    width: "60%",
    center: "",
    "append-to-body": "",
    onOpen: _ctx.handleCallBackShow
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, { onClick: _ctx.handleCancel }, {
            default: _withCtx(() => [
              _createTextVNode(" 取消 ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.handleSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 保存 ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_4, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.handleAddSecondMenu
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 添加二级菜单 ")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "warning",
          disabled: !_ctx.selected.length,
          onClick: _ctx.handleDeleteFirstMenu
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 删除二级菜单 ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      (_ctx.secondMenuList.length)
        ? (_openBlock(), _createBlock(_component_el_table, {
            key: 0,
            data: _ctx.secondMenuList,
            style: {"width":"100%"},
            height: "400px",
            "row-key": _ctx.handleRowKey,
            onSelectionChange: _ctx.handleSelectionChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "selection",
                width: "55"
              }),
              _createVNode(_component_el_table_column, { type: "expand" }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_form, {
                    "label-width": "150px",
                    style: {"max-width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "服务类型：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    placeholder: "请选择",
                                    style: {"width":"100%"},
                                    modelValue: row.secondList.serviceType,
                                    "onUpdate:modelValue": ($event: any) => ((row.secondList.serviceType) = $event)
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.HANDLE_SERVICE_TYPE_LIST, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "后端服务：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: row.secondList.serviceName,
                                    "onUpdate:modelValue": ($event: any) => ((row.secondList.serviceName) = $event),
                                    style: {"width":"100%"},
                                    filterable: "",
                                    clearable: "",
                                    remote: "",
                                    "reserve-keyword": "",
                                    placeholder: "请选择关联后端服务",
                                    onFocus: _ctx.handleSearchService,
                                    onChange: ($event: any) => (_ctx.handleSelectServiceItem($event, row.secondList))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.servicesList, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.serviceName,
                                          label: item.serviceName,
                                          value: item.serviceName
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "onFocus", "onChange"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "后端第一负责人：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    disabled: "",
                                    modelValue: row.secondList.firstHeadBackend,
                                    "onUpdate:modelValue": ($event: any) => ((row.secondList.firstHeadBackend) = $event),
                                    placeholder: "关联后端服务后自动输入"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "后端备选负责人：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    disabled: "",
                                    modelValue: row.secondList.secondHeadBackend,
                                    "onUpdate:modelValue": ($event: any) => ((row.secondList.secondHeadBackend) = $event),
                                    placeholder: "关联后端服务后自动输入"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "前端第一负责人：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    type: "text",
                                    style: {"width":"100%"},
                                    remote: "",
                                    filterable: "",
                                    clearable: "",
                                    modelValue: row.secondList.headOfDevelopment,
                                    "onUpdate:modelValue": ($event: any) => ((row.secondList.headOfDevelopment) = $event),
                                    loading: _ctx.fuzzyLoading,
                                    "remote-method": _ctx.fuzzyRemoteMethod,
                                    onChange: ($event: any) => (_ctx.handleSelectRemoteItem($event, row.secondList, _ctx.FIRST_PEOPLE_ENUM.DEVELOPMENT_FIRST))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fuzzyResponse, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          value: item,
                                          label: `${item.label}${item.bbCode}`,
                                          key: item.value
                                        }, null, 8, ["value", "label"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "loading", "remote-method", "onChange"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "前端备选负责人：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    type: "text",
                                    style: {"width":"100%"},
                                    remote: "",
                                    filterable: "",
                                    clearable: "",
                                    modelValue: row.secondList.secondHeadOfDevelopment,
                                    "onUpdate:modelValue": ($event: any) => ((row.secondList.secondHeadOfDevelopment) = $event),
                                    loading: _ctx.fuzzyLoading,
                                    "remote-method": _ctx.fuzzyRemoteMethod,
                                    onChange: ($event: any) => (_ctx.handleSelectRemoteItem($event, row.secondList, _ctx.FIRST_PEOPLE_ENUM.DEVELOPMENT_SECOND))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fuzzyResponse, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          value: item,
                                          label: `${item.label}${item.bbCode}`,
                                          key: item.value
                                        }, null, 8, ["value", "label"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "loading", "remote-method", "onChange"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "测试第一负责人：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    type: "text",
                                    style: {"width":"100%"},
                                    remote: "",
                                    filterable: "",
                                    clearable: "",
                                    modelValue: row.secondList.headOfTest,
                                    "onUpdate:modelValue": ($event: any) => ((row.secondList.headOfTest) = $event),
                                    loading: _ctx.fuzzyLoading,
                                    "remote-method": _ctx.fuzzyRemoteMethod,
                                    onChange: ($event: any) => (_ctx.handleSelectRemoteItem($event, row.secondList, _ctx.FIRST_PEOPLE_ENUM.TEST_FIRST))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fuzzyResponse, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          value: item,
                                          label: `${item.label}${item.bbCode}`,
                                          key: item.value
                                        }, null, 8, ["value", "label"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "loading", "remote-method", "onChange"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "测试备选负责人：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    type: "text",
                                    style: {"width":"100%"},
                                    remote: "",
                                    filterable: "",
                                    clearable: "",
                                    modelValue: row.secondList.secondHeadOfTest,
                                    "onUpdate:modelValue": ($event: any) => ((row.secondList.secondHeadOfTest) = $event),
                                    loading: _ctx.fuzzyLoading,
                                    "remote-method": _ctx.fuzzyRemoteMethod,
                                    onChange: ($event: any) => (_ctx.handleSelectRemoteItem($event, row.secondList, _ctx.FIRST_PEOPLE_ENUM.TEST_SECOND))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fuzzyResponse, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          value: item,
                                          label: `${item.label}${item.bbCode}`,
                                          key: item.value
                                        }, null, 8, ["value", "label"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "loading", "remote-method", "onChange"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, { prop: "secondLevelMenu" }, {
                default: _withCtx(({ row, $index }) => [
                  _createVNode(_component_el_form, {
                    "label-width": "100px",
                    style: {"width":"100%"},
                    ref: (el) => { if (el) _ctx.secondRuleFormRefList[$index] = el },
                    rules: _ctx.secondRules,
                    model: row.secondList
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "二级菜单：",
                        prop: "secondLevelMenu"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: row.secondList.secondLevelMenu,
                            "onUpdate:modelValue": ($event: any) => ((row.secondList.secondLevelMenu) = $event),
                            style: {"width":"100%"},
                            filterable: "",
                            "allow-create": "",
                            clearable: "",
                            remote: "",
                            "reserve-keyword": "",
                            "remote-method": _ctx.handleSearchSecondMenuList,
                            onKeyup: _withKeys(_ctx.handleAddSecondMenu, ["enter"]),
                            onChange: ($event: any) => (_ctx.handleShowTip($event, row)),
                            placeholder: "请输入二级菜单（按enter添加下一条）"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secondMenuOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "remote-method", "onKeyup", "onChange"]),
                          (row.isShowTip)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, " 你将新建【" + _toDisplayString(row.secondList.secondLevelMenu) + "】二级菜单 ", 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["rules", "model"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "row-key", "onSelectionChange"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "onOpen"]))
}